module.exports = (expression, component) => {
    return {
        ...component,
        route: {
            canActivate: function (transition) {
                let SCI = require('sci');

                let user = SCI.get('user');

                let result = false
                if (typeof expression === 'function') {
                    result = expression(user)
                } else {
                    result = user.guards[expression]
                }

                if (!result) {
                    transition.abort();
                } else {
                    transition.next()
                }
            },
            canReuse: () => false
        }
    }
};



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/helpers/route-guard.js